import React from 'react';

import { useTranslation } from 'react-i18next';

import { Typography } from '../../../DesignSystem';
import '../NftSidePanel.scss';

export const YatMintedFeedback = () => {
    const { t } = useTranslation(['nft', 'translation']);

    return (
        <div className="yat-nft-sidebar__step yat-nft-sidebar__minted-feedback">
            <div className="yat-nft-sidebar__flex-item">
                <Typography type="headline" size={40} classes={['yat-nft-sidebar__title']}>
                    {t('your_item_was_minted', { item: t('translation:yat') })}
                </Typography>
            </div>
        </div>
    );
};
